const videoThumbnailMap: Record<string, string> = {
  "How to inject Trimix": "HowToInjectTrimix.png",
  "How to mix Trimix": "HowToMixTrimix.png",
  "What Is Priapism?": "WhatIsPriapism.png",
};

export const DEFAULT_THUMBNAIL = "DefaultThumbnail.png";
export default videoThumbnailMap;

export const dummyImage = "/images/trimix/image-not-found.png";
